import { isPlainObject } from "lodash";
import { useEffect } from "react";
import { CompletedTodo } from "shared/todos/CompletedTodo";
import useTodosReducer, { State } from "./useTodosReducer";

type SignedOutCompletedTodoLocalStorage = {
  [todoId: number]: CompletedTodo;
};

const signedOutToDoKey = "signedout-completed-todos";

export function getSignedOutCompletedTodosFromStorage() {
  const fetchFromStorage = (): SignedOutCompletedTodoLocalStorage => {
    try {
      const item = localStorage.getItem(signedOutToDoKey);

      if (!item) {
        return {};
      }

      const parsed = JSON.parse(item);

      if (isPlainObject(parsed)) {
        return parsed;
      }
    } catch (e) {}

    return {};
  };

  return new Set(Object.keys(fetchFromStorage()).map((x) => parseInt(x, 10)));
}

export default function useCompletedTodoLocaleStorageSync([state]: ReturnType<
  typeof useTodosReducer
>) {
  useEffect(() => {
    const storageShape: SignedOutCompletedTodoLocalStorage = Array.from(
      state.completedTodos.signedOut
    ).reduce((acc, todoId) => {
      acc[todoId] = { id: Math.random(), todo_id: todoId };

      return acc;
    }, {} as SignedOutCompletedTodoLocalStorage);

    localStorage.setItem(signedOutToDoKey, JSON.stringify(storageShape));
  }, [state.completedTodos.signedOut]);
}
